import React from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../../../tailwind/tabs";
import { cn } from "../../../../lib/utils";

const tabTriggerClass = cn(
  "relative px-4 py-2.5 text-sm font-medium rounded-none border-b-2 border-transparent",
  "bg-transparent shadow-none text-gray-500 dark:text-gray-400",
  "hover:text-gray-900 dark:hover:text-white",
  "data-[state=active]:bg-transparent data-[state=active]:shadow-none",
  "data-[state=active]:border-[hsl(158,48%,36%)] data-[state=active]:text-gray-900 dark:data-[state=active]:text-white",
  "transition-colors"
);

export const BillingTabs = ({ activeTab, setActiveTab, subscriptionPlansTab, billingHistoryTab, metaWalletTab }) => (
  <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
    <div className="border-b border-gray-200 dark:border-slate-800 mb-6">
      <TabsList className="bg-transparent p-0 h-auto gap-0 w-full justify-start rounded-none">
        <TabsTrigger value="subscription-plans" className={tabTriggerClass}>
          Subscription Plans
        </TabsTrigger>
        <TabsTrigger value="billing-history" className={tabTriggerClass}>
          Billing History
        </TabsTrigger>
        <TabsTrigger value="meta-wallet" className={tabTriggerClass}>
          Wallet
        </TabsTrigger>
      </TabsList>
    </div>

    <TabsContent value="subscription-plans" className="mt-0 outline-none focus-visible:ring-0">
      {subscriptionPlansTab}
    </TabsContent>
    <TabsContent value="billing-history" className="mt-0 outline-none focus-visible:ring-0">
      {billingHistoryTab}
    </TabsContent>
    <TabsContent value="meta-wallet" className="mt-0 outline-none focus-visible:ring-0">
      {metaWalletTab}
    </TabsContent>
  </Tabs>
);
